import { sendToBusinessCentral } from "../utils/businessCentralUtils";
import { addCampaign, cleanupCampaigns } from "./campaignService";
import { anotarAviso, anotarError, anotarLectura, anotarSinNovedades } from "./syncLog";

// Nombre con el que esta entidad aparece en las líneas de consola.
const ENTIDAD = "campañas";

// Función para sincronizar campañas desde Business Central
export const syncCampaigns = async () => {
  try {
    // Nada de "iniciando": el cierre de la lectura ya dice qué pasó, y una
    // línea de apertura por catálogo llena la consola sin aportar. Sólo se
    // anuncian los pasos que pueden quedar sin cierre.

    // Obtener datos de Business Central
    const response = await sendToBusinessCentral("Importaciones_getactiveCampaigns", {}, true);

    if (!response || !response.value) {
      anotarAviso(ENTIDAD, "Business Central no devolvió respuesta");
      return false;
    }

    const data = JSON.parse(response.value);

    // Limpiar campañas existentes
    await cleanupCampaigns();

    // Procesar campañas activas
    if (data.Active_Campaings && data.Active_Campaings.length > 0) {
      for (const campaign of data.Active_Campaings) {
        await addCampaign({
          No: campaign.No,
          Description: campaign.Description,
          Starting_Date: campaign.Starting_Date,
          Ending_Date: campaign.Ending_Date,
          Sales_Prices: JSON.stringify(campaign.Sales_Prices || []),
          Line_Discounts: JSON.stringify(campaign.Line_Discounts || []),
        });
      }

      anotarLectura(ENTIDAD, { guardados: data.Active_Campaings.length });
    } else {
      anotarSinNovedades(ENTIDAD);
    }

    return true;
  } catch (error) {
    anotarError(ENTIDAD, "falló la lectura", error);
    return false;
  }
};
